import { Money } from 'shared/types/product';

export const centsToDollarString = (
  centsAmount?: number,
  fractionDigits?: number,
) => {
  const dollarAmount = (centsAmount ?? 0) / 10 ** (fractionDigits ?? 2);
  return `$${dollarAmount.toFixed(fractionDigits)}`;
};

export const centsToDollars = ({ centAmount, fractionDigits }: Money = {}) =>
  (centAmount ?? 0) / 10 ** (fractionDigits ?? 2);

export const centsToDollarStringFormatted = (
  centsAmount?: number,
  fractionDigits?: number,
) => {
  const dollarAmount = (centsAmount ?? 0) / 10 ** (fractionDigits ?? 2);
  return dollarAmount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits ?? 2,
    maximumFractionDigits: fractionDigits ?? 2,
  });
};
